import { getData, postData, putData } from "../../../services/api"


export const getItemDiscardBalanceList = async (branchNo) => {
    let _params = `${branchNo ? '?branchNo=' + branchNo : ''}`

    const res = await getData('discard-seed/balance' + _params)
    if (res.status === true) {
        return res.result
    } else {
        return null
    }

}

export const getCustomersList = async (keyword) => {
    let _params = `${keyword ? '&name=' + keyword : ''}`

    const res = await getData('customers' + '?checkAgentExpired=1' + _params )
    if (res.status === true) {
        return res.result
    } else {
        return null
    }

}
export const getSaleItemList = async (branchNo) => {
    let _params = `${branchNo ? '?branchNo=' + branchNo : ''}`

    const res = await getData('sale/items' + _params)
    if (res.status === true) {
        return res.result
    } else {
        return null
    }

}
export const getLotItemList = async (ItemNo) => {
    let _params = ItemNo ? `/${ItemNo}/lots` : ''

    const res = await getData('sale/items' + _params)
    if (res.status === true) {
        return res.result
    } else {
        return null
    }

}


export const getReserveCustomer = async (CustomerNo, ReserveNo) => {
    let _params = `${ReserveNo ? `/${ReserveNo}/items` : ''}`

    const res = await getData(`sale/customers/${CustomerNo}/reserves` + _params)
    if (res.status === true) {
        return res.result
    } else {
        return null
    }

}

export const addSaleDois = async (body) => {
    const res = await postData(`sale/dois`, body)
    if (res.status === true) {
        return res
    } else {
        return null
    }
}

